import React, { Component } from 'react'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Card, CardBody, Row, Col, Label, Button, Alert, CardHeader, Input } from "reactstrap";
import { Textbox } from "react-inputs-validation";
import { urlModelosAutosRCA, urlConsultarCedula, urlConsultarIdentificacion } from '../../constants/urls'
import { apiGet } from '../../api/index'
import { httpClient } from '../../api/httpClient'
import { vehiculoConst } from '../../constants'
import Select1 from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { formatoReactSelect } from '../../redux/selectors/varios'
import { Checkbox, Select } from "react-inputs-validation";
import { apiPost2 } from "../../api";


const onlyDigits = s => (s || '').replace(/\D+/g, '');
const pickIdentRecord = (raw = {}) =>
(Array.isArray(raw.datosIdentificador) && raw.datosIdentificador.length
    ? raw.datosIdentificador[0]
    : raw);

export default class DatosVehiculo extends Component {

    constructor(props) {
        super(props);

        const {
            datosProducto: dataVehi,
            datosCliente = {},
            placa,
            conductorDiferenteProp = false,
            propietarioDiferenteProp = false,
        } = this.props;

        // ---- Propietario base (para precargar asegurado y, si aplica, conductor no-diferente)
        const p = this.props.propietario || {};
        const baseOwner = (p && (p.cedula || p.nombre || p.direccion || p.telefono))
            ? {
                cedula: p.cedula || '',
                nombre: p.nombre || '',
                direccion: p.direccion || '',
                telefono: p.telefono || '',
            }
            : {
                cedula: datosCliente.cedulaConductor || '',
                nombre: datosCliente.nombreConductor || '',
                direccion: datosCliente.direccionConductor || '',
                telefono: datosCliente.telefonoConductor || '',
            };

        // ---- Vehículo inicial
        const datosVehiculo = dataVehi ? { ...dataVehi } : vehiculoConst;

        // ---- Errores iniciales (corregidos con &&)
        let hasModeloError = !(datosVehiculo && `${datosVehiculo.modeloCodigo}` !== '' && `${datosVehiculo.modeloCodigo}` !== '-1');
        let hasColorError = !(datosVehiculo && (`${datosVehiculo.colorCodigo}` !== '' || `${datosVehiculo.colorNombre}` !== ''));
        let hasProcedenciaError = !(datosVehiculo && (`${datosVehiculo.procedenciaCodigo}` !== '' || `${datosVehiculo.procedenciaNombre}` !== ''));
        let hasCategoriaError = (datosVehiculo && `${datosVehiculo.modeloCodigo}` === '-1' && (!datosVehiculo.categoriaCodigo || `${datosVehiculo.categoriaCodigo}` === ''));

        // ---- Datos del paso 1
        const cedulaPantalla1 = datosCliente.cedulaConductor || '';
        const nombrePantalla1 = datosCliente.nombreConductor || '';
        const dirPantalla1 = datosCliente.direccionConductor || '';
        const telPantalla1 = datosCliente.telefonoConductor || '';

        // ---- Personería como string
        const defaultConductorPersoneria = String(this.props.personeria || '1');
        const defaultPropPersoneria = String(this.props.personeria || '1');

        // ---- ¿El conductor es diferente?
        const conductorEsDiferente = !!conductorDiferenteProp;

        // Si NO es diferente, inicializa el nombre del conductor con lo que ya hay (paso 1 o propietario)
        const initNombreConductor =
            !conductorEsDiferente
                ? (nombrePantalla1 || baseOwner.nombre || '')
                : (nombrePantalla1 || '');

        // Cédula del conductor: usa la del paso 1; si no hay y no es diferente, cae al propietario
        const initCedulaConductor =
            cedulaPantalla1 || (!conductorEsDiferente ? (baseOwner.cedula || '') : '');

        // Dirección / Teléfono del conductor (por si necesitas mostrarlos)
        const initDirConductor = dirPantalla1;
        const initTelConductor = telPantalla1;

        this.state = {
            // generales
            validate: false,
            loading: false,

            // personería
            conductorPersoneria: defaultConductorPersoneria,

            // ---- Conductor
            conductorDiferente: conductorEsDiferente,
            cedulaConductor: initCedulaConductor,
            nombreConductor: initNombreConductor,
            direccionConductor: initDirConductor,
            telefonoConductor: initTelConductor,

            // Mantén un respaldo de lo que vino del paso 1 / propietario
            backupInit: {
                cedulaConductor: initCedulaConductor,
                nombreConductor: initNombreConductor, // <- clave para que el input disabled muestre el texto
                direccionConductor: initDirConductor,
                telefonoConductor: initTelConductor,
                conductorPersoneria: defaultConductorPersoneria,
            },
            backupOtro: { cedulaConductor: '', nombreConductor: '' },


            // errores de conductor coherentes con lo anterior (no deberían marcar error si está deshabilitado)
            hasCedulaError: false,
            hasNombreError: false,

            // vehículo
            modelos: [],
            datosVehiculo: { ...datosVehiculo, placa },
            hasAnioError: !(!!datosVehiculo.anio),
            hasChasisError: !(!!datosVehiculo.chasis),
            hasMarcaError: !(!!datosVehiculo.marcaNombre),
            hasModeloError,
            hasColorError,
            hasProcedenciaError,
            hasCategoriaError,
            hasMotorError: !(!!datosVehiculo.motor),

            // ---- Asegurado / Propietario
            propietarioDiferente: !!propietarioDiferenteProp,
            propPersoneria: defaultPropPersoneria,
            propCedula: defaultPropPersoneria !== '2' ? baseOwner.cedula :'' ,
            propNombre: defaultPropPersoneria !== '2' ? baseOwner.nombre: '',
            propDireccion: defaultPropPersoneria !== '2' ?  baseOwner.direccion: '',
            propTelefono: defaultPropPersoneria !== '2' ? baseOwner.telefono: '',

            propBackupInit: { ...baseOwner, personeria: defaultPropPersoneria },
            propBackupOtro: { cedula: '', nombre: '', direccion: '', telefono: '', personeria: '1' },

            // errores propietario
            hasPropCedulaError: false,
            hasPropNombreError: false,
            hasPropDireccionError: false,
            hasPropTelefonoError: false,

            // hidrataciones
            hydratedConductor: false,
            hydratedPropietario: false,
        };
        console.log('ESTADO CONST');
    }

    updatePropField = (key, val) => {
        this.setState(prev => {
            const next = { [key]: val };
            if (prev.propietarioDiferente) {
                next.propBackupOtro = {
                    ...prev.propBackupOtro,
                    [key.replace('prop', '').toLowerCase()]: val
                };
            }
            return next;
        });
    };

    componentDidMount() {
        const { marcaCodigo } = this.state.datosVehiculo
        const { modelos } = this.props

        if ((marcaCodigo && `${marcaCodigo}` !== '-1') && !modelos) {
            this.consultarModelos(marcaCodigo)
        } else if (modelos) this.setState({ modelos })
        setTimeout(() => this.toggleValidate(2000), 1000)

        window.scroll(0, 0)
        const { cedulaConductor } = this.state;
        if (cedulaConductor) {
            this.consultaCargarDatos(cedulaConductor);
        }
    }


    onToggleConductorDiferente = (checked) => {
        if (checked) {
            // activar “diferente”: resetear a personería 1 y vaciar campos del conductor
            this.setState(prev => ({
                conductorDiferente: true,
                validate: true,
                backupOtro: {
                    cedulaConductor: prev.cedulaConductor || '',
                    nombreConductor: prev.nombreConductor || '',
                },

                // 🔁 reset del select y los campos
                conductorPersoneria: '',
                cedulaConductor: '',
                nombreConductor: '',
                direccionConductor: '',
                telefonoConductor: '',

                // errores para obligar captura
                hasCedulaError: true,
                hasNombreError: true,
            }), () => {
                this.props.onChangeConductorDiferente && this.props.onChangeConductorDiferente(true);
            });

        } else {
            // desactivar “diferente”: restaurar lo que vino del paso 1 / backupInit
            this.setState(prev => {
                const bi = prev.backupInit || {};
                return {
                    conductorDiferente: false,
                    validate: true,

                    // 🔁 restaurar personería y valores iniciales
                    conductorPersoneria: String(bi.personeria || this.props.personeria || '1'),
                    cedulaConductor: bi.cedulaConductor || '',
                    nombreConductor: bi.nombreConductor || '',
                    direccionConductor: bi.direccionConductor || '',
                    telefonoConductor: bi.telefonoConductor || '',

                    hasCedulaError: false,
                    hasNombreError: false,
                };
            }, () => {
                this.props.onChangeConductorDiferente && this.props.onChangeConductorDiferente(false);
            });
        }
    };

    // ===== CONDUCTOR =====
    consultaCargarDatos = async (ident) => {
        try {
            this.setState({ loading: true });

            const per = String(this.state.conductorPersoneria || this.props.personeria || '1');
            let data = {};

            if (per === '2') {
                // Jurídica (RUC) -> POST
                data = (await apiPost2(urlConsultarIdentificacion, {
                    tipo: 'ruc',
                    leerCache: true,
                    identificador: ident,
                })) || {};
            } else {
                // Natural -> GET
                data = (await httpClient.get(urlConsultarCedula + ident)) || {};
            }

            const rec = pickIdentRecord(data);

            const nombreConductor = (per === '2')
                ? (rec.nombre || '').trim() // razón social
                : (
                    `${(rec.nombres || '').trim()} ${(rec.apellidos || '').trim()}`.trim()
                    || (rec.nombre || '').trim()
                );

            let direccionConductor = (rec.direccion || rec.direccion_domicilio || '').trim();
            if (!direccionConductor) {
                const direccionesStr = (data.direcciones || '').toString();
                const direccionesArr = direccionesStr.split(',');
                direccionConductor = (direccionesArr[0] || '').trim();
            }

            let telefonoConductor = onlyDigits(rec.celular || rec.telefono_celular || rec.telefono || '');
            if (!telefonoConductor) {
                const mix = `${data.celulares || ''},${data.telefonos || ''}`.split(',');
                for (const t of mix) {
                    const clean = onlyDigits(t);
                    if (clean) { telefonoConductor = clean; break; }
                }
            }

            this.setState(prev => ({
                loading: false,
                validate: true,
                nombreConductor,
                direccionConductor,
                telefonoConductor,
                hasNombreError: !nombreConductor,
                hasDireccionError: !direccionConductor,
                hasTelefonoError: !telefonoConductor,
                // refrescamos backupInit para que isLocked funcione coherente al volver a “no diferente”
                backupInit: {
                    ...prev.backupInit,
                    nombreConductor,
                    direccionConductor,
                    telefonoConductor,
                },
            }));

            setTimeout(() => this.toggleValidate(false), 300);
        } catch (err) {
            console.error('consultaCargarDatos error:', err);
            this.setState({ loading: false });
        }
    };




    consultarModelos = async (id) => {
        const { transaccion, modelos } = await apiGet(urlModelosAutosRCA + id)
        console.log('data modelos', modelos)
        if (transaccion)
            this.setState({ modelos })
    }


    componentDidUpdate(prevProps, prevState) {
        const { datosProducto, datosManuales, datosCliente = {} } = this.props;

        // A) Si cambia la personería del paso 1, reflejarla cuando NO son "diferentes"
        if (prevProps.personeria !== this.props.personeria) {
            const nuevaPer = String(this.props.personeria || '1');

            this.setState(state => {
                const next = {};
                if (!state.conductorDiferente && String(state.conductorPersoneria) !== nuevaPer) {
                    next.conductorPersoneria = nuevaPer;
                }
                if (!state.propietarioDiferente && String(state.propPersoneria) !== nuevaPer) {
                    next.propPersoneria = nuevaPer;
                    next.propBackupInit = { ...state.propBackupInit, personeria: nuevaPer };
                }
                return Object.keys(next).length ? next : null;
            });
        }

        // B) Actualizar vehículo si cambió (prop -> state)
        if (datosManuales !== prevProps.datosManuales || datosProducto !== prevProps.datosProducto) {
            this.setState({ datosVehiculo: datosProducto, datosManuales });
        }

        // C) Sincronizar CONDUCTOR desde props si NO es diferente y aún no se hidrató
        if (!this.state.conductorDiferente && !this.state.hydratedConductor) {
            const cedulaPantalla1 = datosCliente.cedulaConductor || '';
            const nombrePantalla1 = datosCliente.nombreConductor || '';
            const dirPaso1 = datosCliente.direccionConductor || '';
            const telPaso1 = datosCliente.telefonoConductor || '';

            const hayCambioUtil =
                (cedulaPantalla1 && cedulaPantalla1 !== this.state.cedulaConductor) ||
                (nombrePantalla1 && nombrePantalla1 !== this.state.nombreConductor) ||
                (dirPaso1 && dirPaso1 !== this.state.direccionConductor) ||
                (telPaso1 && telPaso1 !== this.state.telefonoConductor);

            if (hayCambioUtil) {
                this.setState(prev => ({
                    cedulaConductor: cedulaPantalla1 || prev.cedulaConductor,
                    nombreConductor: nombrePantalla1 || prev.nombreConductor,
                    direccionConductor: dirPaso1 || prev.direccionConductor,
                    telefonoConductor: telPaso1 || prev.telefonoConductor,
                    hasCedulaError: false,
                    hasNombreError: false,
                    backupInit: {
                        cedulaConductor: cedulaPantalla1 || prev.cedulaConductor,
                        nombreConductor: nombrePantalla1 || prev.nombreConductor,
                        direccionConductor: dirPaso1 || prev.direccionConductor,
                        telefonoConductor: telPaso1 || prev.telefonoConductor,
                        // si quieres guardar también la personería inicial del conductor:
                        personeria: this.props.personeria || '1',
                    },
                    hydratedConductor: true,
                }));
            }
        }

        // D) Sincronizar PROPIETARIO con datos del paso 1 si NO es diferente y aún no se hidrató
        const prevCli = prevProps.datosCliente || {};
        const nowCli = datosCliente || {};
        const propietarioCambio =
            prevCli.cedulaConductor !== nowCli.cedulaConductor ||
            prevCli.nombreConductor !== nowCli.nombreConductor ||
            prevCli.direccionConductor !== nowCli.direccionConductor ||
            prevCli.telefonoConductor !== nowCli.telefonoConductor;

        if (!this.state.propietarioDiferente && !this.state.hydratedPropietario && propietarioCambio) {
            const p = this.props.propietario || {};
            const ced = p.cedula || nowCli.cedulaConductor || '';
            const nom = p.nombre || nowCli.nombreConductor || '';
            const dir = p.direccion || nowCli.direccionConductor || '';
            const tel = p.telefono || nowCli.telefonoConductor || '';
            const perPaso1 = this.props.personeria || '1'; // <-- DEFINIDO AQUÍ

            this.setState(prev => ({
                propCedula: ced || prev.propCedula,
                propNombre: nom || prev.propNombre,
                propDireccion: dir || prev.propDireccion,
                propTelefono: tel || prev.propTelefono,
                hasPropCedulaError: !ced,
                hasPropNombreError: !nom,
                hasPropDireccionError: !dir,
                hasPropTelefonoError: !tel,
                propPersoneria: perPaso1,                             // <-- OK
                propBackupInit: {                                     // <-- UNA SOLA VEZ
                    cedula: ced, nombre: nom, direccion: dir, telefono: tel, personeria: perPaso1,
                },
                hydratedPropietario: true,
            }));
        }

        // E) Copiar teléfono del conductor al propietario (si propietario no es diferente y está vacío)
        if (!this.state.propietarioDiferente && this.state.propPersoneria !== '2') {
            const prevTelCon = (prevState && prevState.telefonoConductor) || '';
            const nowTelCon = this.state.telefonoConductor || '';
            const propTelVacio = !String(this.state.propTelefono || '').trim();

            if (!prevTelCon && nowTelCon && propTelVacio) {
                this.setState(prev => ({
                    propTelefono: nowTelCon,
                    propBackupInit: { ...prev.propBackupInit, telefono: nowTelCon },
                    hasPropTelefonoError: false,
                }));
            }
        }
    }


    toggleValidate = (validate) => {
        this.setState({ validate })
    }

    onClick = () => {
        this.toggleValidate(true);
        console.log('ESTADO', this.state);
        const paso = 2;

        const {
            hasAnioError,
            hasCedulaError,
            hasChasisError,
            hasColorError,
            hasMarcaError,
            hasModeloError,
            hasMotorError,
            hasNombreError,
            hasCategoriaError,
        } = this.state;

        // Validar errores de vehículo
        const vehiculoOk =
            !hasAnioError &&
            !hasCedulaError &&
            !hasChasisError &&
            !hasColorError &&
            !hasMarcaError &&
            !hasModeloError &&
            !hasMotorError &&
            !hasNombreError &&
            !hasCategoriaError;

        if (!vehiculoOk) return; // no continúa si hay errores de vehículo

        let {
            cedulaConductor,
            nombreConductor,
            direccionConductor,
            telefonoConductor,
            datosVehiculo,
            modelos,
        } = this.state;

        const { colores, marcas, procedencia, categorias, checkPlaca, setMostrarError } = this.props;

        // Completar nombres de catálogos
        if (datosVehiculo.marcaCodigo && !datosVehiculo.marcaNombre && `${datosVehiculo.marcaCodigo}` !== `-1`)
            datosVehiculo.marcaNombre = marcas.find(({ id }) => `${id}` === `${datosVehiculo.marcaCodigo}`).name;

        if (datosVehiculo.modeloCodigo && !datosVehiculo.modeloNombre && `${datosVehiculo.modeloCodigo}` !== `-1`)
            datosVehiculo.modeloNombre = modelos.find(({ id }) => `${id}` === `${datosVehiculo.modeloCodigo}`).name;

        if (datosVehiculo.colorCodigo && !datosVehiculo.colorNombre && `${datosVehiculo.colorCodigo}` !== `-1`)
            datosVehiculo.colorNombre = colores.find(({ id }) => `${id}` === `${datosVehiculo.colorCodigo}`).name;

        if (datosVehiculo.procedenciaCodigo && !datosVehiculo.procedenciaNombre && `${datosVehiculo.procedenciaCodigo}` !== `-1`)
            datosVehiculo.procedenciaNombre = procedencia.find(({ id }) => `${id}` === `${datosVehiculo.procedenciaCodigo}`).name;

        if (datosVehiculo.categoriaCodigo && !datosVehiculo.categoriaNombre && `${datosVehiculo.categoriaCodigo}` !== `-1`)
            datosVehiculo.categoriaNombre = categorias.find(({ id }) => `${id}` === `${datosVehiculo.categoriaCodigo}`).name;

        // Validaciones de propietario (asegurado)
        const {
            hasPropCedulaError,
            hasPropNombreError,
            hasPropDireccionError,
            hasPropTelefonoError,
            propCedula,
            propNombre,
            propDireccion,
            propTelefono,
            propietarioDiferente,
        } = this.state;

        const propietarioOk =
            !hasPropCedulaError &&
            !hasPropNombreError &&
            !hasPropDireccionError &&
            !hasPropTelefonoError &&
            propCedula &&
            propNombre &&
            propDireccion &&
            propTelefono;

        if (!propietarioOk) {
            this.toggleValidate(true);
            return;
        }

        // Si el checkbox de placa está marcado, proceder
        if (checkPlaca) {
            this.props.handleNext({
                params: {
                    cedulaConductor,
                    nombreConductor,
                    direccionConductor,
                    telefonoConductor,
                    personeriaConductor: Number(this.state.conductorPersoneria || this.props.personeria || '1'),
                    datosVehiculo: [datosVehiculo],
                    propietario: {
                        cedula: propCedula,
                        nombre: propNombre,
                        direccion: propDireccion,
                        telefono: propTelefono,
                        diferente: propietarioDiferente,
                        personeria: Number(this.state.propPersoneria || this.props.personeria || '1'),
                    },
                    conductorDiferente: this.state.conductorDiferente,
                },
                paso,
            });
        } else {
            setMostrarError(true);
        }
    };


    // Toggle del checkbox "¿El propietario es diferente al contratante?"
    onTogglePropietarioDiferente = (checked) => {
        if (checked) {
            this.setState(prev => ({
                propietarioDiferente: true,
                validate: true,
                propBackupOtro: {
                    cedula: prev.propCedula,
                    nombre: prev.propNombre,
                    direccion: prev.propDireccion,
                    telefono: prev.propTelefono,
                    personeria: prev.propPersoneria || '',      // <-- guarda lo actual
                },
                // limpiar para obligar captura
                propCedula: '', propNombre: '', propDireccion: '', propTelefono: '',
                propPersoneria: '',                           // <-- vuelve a 1 por defecto
                hasPropCedulaError: true, hasPropNombreError: true,
                hasPropDireccionError: true, hasPropTelefonoError: true,
            }), () => {
                this.props.onChangePropietarioDiferente && this.props.onChangePropietarioDiferente(true);
            });

        } else {
            this.setState(prev => ({
                propietarioDiferente: false,
                validate: true,
                // restaurar lo del paso 1 (backupInit)
                propCedula: prev.propBackupInit.personeria !== '2' ? prev.propBackupInit.cedula || '' : '',
                propNombre: prev.propBackupInit.personeria !== '2' ? prev.propBackupInit.nombre || '' : '',
                propDireccion: prev.propBackupInit.personeria !== '2' ? prev.propBackupInit.direccion || '' : '',
                propTelefono: prev.propBackupInit.personeria !== '2' ? prev.propBackupInit.telefono || '' : '',
                propPersoneria: prev.propBackupInit.personeria || (this.props.personeria || '1'), // <-- restaura
                hasPropCedulaError: false, hasPropNombreError: false,
                hasPropDireccionError: false, hasPropTelefonoError: false,
            }), () => {
                this.props.onChangePropietarioDiferente && this.props.onChangePropietarioDiferente(false);
            });
        }
    };


    // ===== PROPIETARIO / ASEGURADO =====
    consultaCargarDatosProp = async (ident) => {
        try {
            this.setState({ loading: true });

            const per = String(this.state.propPersoneria || this.props.personeria || '1');
            let data = {};

            if (per === '2') {
                // Jurídica (RUC) -> POST
                data = (await apiPost2(urlConsultarIdentificacion, {
                    tipo: 'ruc',
                    leerCache: true,
                    identificador: ident,
                })) || {};
            } else {
                // Natural -> GET
                data = (await httpClient.get(urlConsultarCedula + ident)) || {};
            }

            const rec = pickIdentRecord(data);

            const nombre = (per === '2')
                ? (rec.nombre || '').trim()
                : (
                    `${(rec.nombres || '').trim()} ${(rec.apellidos || '').trim()}`.trim()
                    || (rec.nombre || '').trim()
                );

            let direccion = (rec.direccion || rec.direccion_domicilio || '').trim();
            if (!direccion) {
                const direccionesStr = (data.direcciones || '').toString();
                const arr = direccionesStr.split(',');
                direccion = (arr[0] || '').trim();
            }

            let telefono = onlyDigits(rec.celular || rec.telefono_celular || rec.telefono || '');
            if (!telefono) {
                const mix = `${data.celulares || ''},${data.telefonos || ''}`.split(',');
                for (const t of mix) {
                    const clean = onlyDigits(t);
                    if (clean) { telefono = clean; break; }
                }
            }

            this.setState({
                loading: false,
                validate: true,
                propNombre: nombre,
                propDireccion: direccion,
                propTelefono: telefono,
                hasPropNombreError: !nombre,
                hasPropDireccionError: !direccion,
                hasPropTelefonoError: !telefono,
            });
        } catch (e) {
            console.error('consultaCargarDatosProp error:', e);
            this.setState({ loading: false });
        }
    };



    // Conductor
    isLocked = (fieldName) => {
        const { conductorDiferente, backupInit = {} } = this.state;
        if (conductorDiferente) return false;
        const initialVal = String((backupInit[fieldName] || '')).trim();
        return initialVal.length > 0;
    };

    // Propietario
    isLockedProp = (fieldName) => {
        const { propietarioDiferente, propBackupInit = {} } = this.state;
        if (propietarioDiferente) return false;
        const initialVal = String((propBackupInit[fieldName] || '')).trim();
        return initialVal.length > 0;
    };


    render() {
        let { colores, marcas = [], procedencia = [], categorias = [], datosManuales, rangoInf, rangoSup } = this.props
        const { validate, loading, cedulaConductor, nombreConductor, datosVehiculo, hasProcedenciaError, hasColorError, hasCategoriaError } = this.state
        const {
            marcaCodigo,
            marcaNombre,
            modeloCodigo,
            modeloNombre,
            anio,
            // placa,
            motor,
            chasis,
            colorCodigo,
            // colorNombre,
            procedenciaCodigo,
            // procedenciaNombre,
            categoriaCodigo,
            categoriaNombre,
        } = datosVehiculo

        const prVehi = this.props.datosProducto

        console.log('PPPP', this.props)
        console.log('modelo', this.state)

        let { modelos = [], } = this.state

        marcas = formatoReactSelect(marcas, 'id', 'name')
        procedencia = formatoReactSelect(procedencia, 'id', 'name')
        categorias = formatoReactSelect(categorias, 'id', 'name')
        modelos = formatoReactSelect(modelos, 'id', 'name')

        if (colores && colores[0] && colores[0].id) colores.splice(0, 1)

        const defaulMarca = marcas.find(item => `${item.value}` === `${marcaCodigo}`)
        const defaulModelos = modelos.find(item => `${item.value}` === `${modeloCodigo}`)
        const defaulColor = colores.find(item => `${item.value}` === `${colorCodigo}`)
        const defaulProcedencia = procedencia.find(item => `${item.value}` === `${procedenciaCodigo}`)
        const defaulCategoria = categorias.find(item => `${item.value}` === `${categoriaCodigo}`)


        return (
            <LoadingScreen
                loading={loading}
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text="Cargando..."
            >
                <div>
                    <Card>
                        <CardHeader> <h4 style={{ fontWeight: 'bold', }}> Datos del Conductor</h4></CardHeader>
                        <CardBody>


                            {/* Personería del CONDUCTOR */}
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <h4><Label for="selectPersoneriaConductor">Seleccione la personería</Label></h4>
                                </Col>
                                <Col sm={7}>
                                    <Select
                                        id="selectPersoneriaConductor"
                                        name="selectPersoneriaConductor"
                                        value={this.state.conductorPersoneria}
                                        optionList={this.props.arrayPersoneria || []}
                                        disabled={!this.state.conductorDiferente} // si no es diferente, que quede bloqueado
                                        onChange={(personeria) => {
                                            // al cambiar personería del conductor, puedes limpiar la identificación para evitar confusiones
                                            this.setState({
                                                conductorPersoneria: String(personeria),
                                                cedulaConductor: '', // opcional pero recomendado
                                                hasCedulaError: !!personeria === '',
                                            });
                                        }}
                                        validate={this.state.validate}
                                        validationCallback={(res) => this.setState({ validate: false })}
                                        onBlur={() => { }}
                                        customStyleOptionListContainer={{}}
                                        validationOption={{
                                            name: "selectPersoneriaConductor",
                                            check: true,
                                            required: this.state.conductorDiferente, // solo obligatorio si es conductor diferente
                                            msgOnError: "Por favor seleccione la personería del conductor",
                                        }}
                                    />
                                </Col>
                            </Row>


                            {/* Identificación */}
                            <Row>
                                <Col sm={4}><h4>Cédula/Ruc/Pasaporte</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type={this.state.conductorPersoneria === '3' ? 'text' : 'number'}
                                        id="cedula"
                                        name="cedula"
                                        classNameInput="form-control"
                                        value={cedulaConductor}
                                        validate={validate}
                                        disabled={this.isLocked('cedulaConductor')}
                                        onBlur={() => { }}
                                        onChange={(ced) => {
                                            this.setState({ cedulaConductor: ced });
                                            const len = (ced || '').trim().length;
                                            const per = String(this.state.conductorPersoneria);
                                            // dispara minería según personería
                                            if ((per === '1' && len === 10) || (per === '2' && len === 13)) {
                                                this.setState({ loading: true });
                                                this.consultaCargarDatos(ced.trim());
                                            }
                                        }}
                                        validationCallback={res => this.setState({ hasCedulaError: res, validate: false })}
                                        validationOption={{
                                            name: "cedula",
                                            check: true,
                                            required: false,
                                            customFunc: (val) => {
                                                if (this.state.conductorDiferente && (val === "" || val === null)) return "Ingrese una identificación válida";
                                                // Seleccionar el regex según conductorPersoneria
                                                const regex =
                                                    this.state.conductorPersoneria === "1"
                                                        ? /^\d{10}$/
                                                        : this.state.conductorPersoneria === "2"
                                                            ? /^\d{13}$/
                                                            : /^[a-zA-Z0-9]*$/;

                                                // Validar con el regex correspondiente
                                                if (!regex.test(val)) {
                                                    if (this.state.conductorPersoneria === "1") {
                                                        return "Ingrese una cédula válida (10 dígitos)";
                                                    } else if (this.state.conductorPersoneria === "2") {
                                                        return "Ingrese un RUC válido (13 dígitos)";
                                                    } else {
                                                        return "Ingrese un pasaporte válido";
                                                    }
                                                }

                                                // Si pasa la validación, devolver true
                                                return true;
                                            },
                                        }}
                                    />

                                </Col>
                            </Row>

                            {/* Nombre */}
                            <Row>
                                <Col sm={4}><h4>Nombre</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type="text"
                                        id="inNomConductor"
                                        name="inNomConductor"
                                        classNameInput="form-control"
                                        value={nombreConductor}
                                        validate={validate}
                                        disabled={this.isLocked('nombreConductor')}
                                        onChange={(nom) => this.setState({ nombreConductor: nom })}
                                        validationCallback={res =>
                                            this.setState({ hasNombreError: res, validate: false })
                                        }
                                        validationOption={{
                                            name: "inNomConductor",
                                            check: true,
                                            required: this.state.conductorDiferente,
                                            msgOnError: "Por favor ingrese el nombre del conductor",
                                        }}
                                    />
                                </Col>
                            </Row>

                            {/* Checkbox: Conductor diferente */}
                            <Row className="mt-2">
                                <Col sm={4} />
                                <Col md={6} sm={8} xs={12}>
                                    <div className="d-flex align-items-center">
                                        <Checkbox
                                            id={"chkConductorDiferente"}
                                            name={"chkConductorDiferente"}
                                            value={this.state.conductorDiferente}
                                            checked={this.state.conductorDiferente}
                                            classNameInputBox={"check-uber"}
                                            onBlur={() => { }}
                                            onChange={(checked) => this.onToggleConductorDiferente(checked)}
                                        />
                                        <Label
                                            htmlFor="chkConductorDiferente"
                                            style={{ fontWeight: 600, marginLeft: 8, cursor: 'pointer' }}
                                        >
                                            ¿El conductor es diferente al contratante?
                                        </Label>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>


                    <Card>
                        <CardHeader><h4 style={{ fontWeight: 'bold' }}>Asegurado - propietario</h4></CardHeader>
                        <CardBody>

                            {/* Personería del ASEGURADO - PROPIETARIO */}
                            <Row className="mt-3">
                                <Col sm={4}>
                                    <h4><Label for="selectPersoneriaProp">Seleccione la personería</Label></h4>
                                </Col>
                                <Col sm={7}>
                                    <Select
                                        id="selectPersoneriaProp"
                                        name="selectPersoneriaProp"
                                        value={this.state.propPersoneria}
                                        optionList={this.props.arrayPersoneria || []}
                                        disabled={!this.state.propietarioDiferente}
                                        onChange={(val) => {
                                            if (val === '2') {
                                                this.setState({
                                                    
                                                    propCedula: '',
                                                    propNombre: '',
                                                    propDireccion: '',
                                                    propTelefono: '',
                                                    propPersoneria: val,
                                                    hasPropCedulaError: true,
                                                });
                                            } else {
                                                this.setState({
                                                    propPersoneria: val,            // <-- guarda selección
                                                    propCedula: '',                 // opcional: limpiar para forzar minería
                                                    hasPropCedulaError: true,
                                                });
                                            }
                                        }}
                                        validate={this.state.validate}
                                        validationCallback={(res) => this.setState({ validate: false })}
                                        validationOption={{
                                            name: "selectPersoneriaProp",
                                            check: true,
                                            required: this.state.propietarioDiferente,
                                            msgOnError: "Por favor seleccione la personería del propietario",
                                        }}
                                    />

                                </Col>
                            </Row>

                            {/* Cédula/Pasaporte (requerido + minería) */}
                            <Row>
                                <Col sm={4}><h4>Cédula/Ruc/Pasaporte</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type={this.state.propPersoneria === '3' ? 'text' : 'number'}
                                        id="propCedula"
                                        name="propCedula"
                                        classNameInput="form-control"
                                        value={this.state.propCedula}
                                        validate={this.state.validate}
                                        disabled={this.isLockedProp('cedula') && this.state.propPersoneria !== '2'}
                                        onBlur={() => { }}
                                        onChange={(val) => {
                                            const v = (val || '').trim();
                                            this.updatePropField('propCedula', v);
                                            const per = this.state.propPersoneria;
                                            const len = v.length;
                                            // dispara minería según personería
                                            if ((per === '1' && len === 10) || (per === '2' && len === 13)) {
                                                this.consultaCargarDatosProp(v);
                                            }
                                        }}
                                        validationCallback={(res) => this.setState({ hasPropCedulaError: res, validate: false })}
                                        validationOption={{
                                            name: "propCedula",
                                            check: true,
                                            required: false,
                                            customFunc: (val) => {
                                                if (val === "" || val === null) return "Ingrese una identificación válida";
                                                // Seleccionar el regex según propPersoneria
                                                const regex =
                                                    this.state.propPersoneria === "1"
                                                        ? /^\d{10}$/
                                                        : this.state.propPersoneria === "2"
                                                            ? /^\d{13}$/
                                                            : /^[a-zA-Z0-9]*$/;

                                                // Validar con el regex correspondiente
                                                if (!regex.test(val)) {
                                                    if (this.state.propPersoneria === "1") {
                                                        return "Ingrese una cédula válida (10 dígitos)";
                                                    } else if (this.state.propPersoneria === "2") {
                                                        return "Ingrese un RUC válido (13 dígitos)";
                                                    } else {
                                                        return "Ingrese un pasaporte válido";
                                                    }
                                                }

                                                // Si pasa la validación, devolver true
                                                return true;
                                            },
                                        }}
                                    />

                                </Col>
                            </Row>

                            {/* Nombre (requerido + minería) */}
                            <Row>
                                <Col sm={4}><h4>Nombre</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type="text"
                                        id="propNombre"
                                        name="propNombre"
                                        classNameInput="form-control"
                                        value={this.state.propNombre}
                                        validate={this.state.validate}
                                        disabled={this.isLockedProp('nombre') && this.state.propPersoneria !== '2'}
                                        onChange={(val) => this.updatePropField('propNombre', val)}
                                        validationCallback={(res) => this.setState({ hasPropNombreError: res, validate: false })}
                                        validationOption={{
                                            name: "propNombre",
                                            check: true,
                                            required: true,
                                            msgOnError: "Ingrese el nombre del propietario",
                                        }}
                                    />
                                </Col>
                            </Row>

                            {/* Dirección (requerido, como Ubicación Pantalla 1) */}
                            <Row>
                                <Col sm={4}><h4>Dirección</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type="text"
                                        id="propDireccion"
                                        name="propDireccion"
                                        classNameInput="form-control"
                                        value={this.state.propDireccion}
                                        validate={this.state.validate}
                                        disabled={this.isLockedProp('direccion') && this.state.propPersoneria !== '2'}
                                        onChange={(val) => this.updatePropField('propDireccion', val)}
                                        validationCallback={(res) => this.setState({ hasPropDireccionError: res, validate: false })}
                                        validationOption={{
                                            name: "propDireccion",
                                            check: true,
                                            required: true,
                                            msgOnError: "Ingrese la dirección del propietario",
                                        }}
                                    />
                                </Col>
                            </Row>

                            {/* Teléfono (requerido + solo números) */}
                            <Row>
                                <Col sm={4}><h4>Teléfono</h4></Col>
                                <Col sm={7}>
                                    <Textbox
                                        type="text"
                                        id="propTelefono"
                                        name="propTelefono"
                                        classNameInput="form-control"
                                        value={this.state.propTelefono}
                                        validate={this.state.validate}
                                        disabled={this.isLockedProp('telefono') && this.state.propPersoneria !== '2'}
                                        onChange={(val) => this.updatePropField('propTelefono', (val || '').replace(/\D+/g, ''))}
                                        validationCallback={(res) => this.setState({ hasPropTelefonoError: res, validate: false })}
                                        onBlur={()=>{}}
                                        validationOption={{
                                            name: "propTelefono",
                                            check: true,
                                            required: false,
                                            customFunc: (val) => {
                                                if (val === "" || val === null) return "Ingrese un número de teléfono";
                                                // Seleccionar el regex según propPersoneria
                                                const regex = /^\d{10}$/;
                                            
                                                // Validar con el regex correspondiente
                                                if (!regex.test(val)) {
                                                    return "Ingrese un teléfono válido (10 dígitos)";
                                                }

                                                // Si pasa la validación, devolver true
                                                return true;
                                            },
                                        }}
                                    />
                                </Col>
                            </Row>

                            {/* Checkbox: propietario diferente */}
                            <Row className="mt-2">
                                <Col sm={4} />
                                <Col md={6} sm={8} xs={12}>
                                    <div className="d-flex align-items-center">
                                        <Checkbox
                                            id="chkPropietarioDiferente"
                                            name="chkPropietarioDiferente"
                                            value={this.state.propietarioDiferente}
                                            checked={this.state.propietarioDiferente}
                                            classNameInputBox="check-uber"
                                            onBlur={() => { }}
                                            onChange={(checked) => this.onTogglePropietarioDiferente(checked)}
                                        />
                                        <Label htmlFor="chkPropietarioDiferente" style={{ fontWeight: 600, marginLeft: 8, cursor: 'pointer' }}>
                                            ¿El propietario es diferente al contratante?
                                        </Label>
                                    </div>
                                </Col>
                            </Row>

                        </CardBody>
                    </Card>

                    {/*********-------------Vehículo----------********/}

                    <Card>
                        <CardHeader> <h4 style={{ fontWeight: 'bold', }}> Datos del Vehículo </h4></CardHeader>
                        <CardBody>

                            < div style={{ display: (datosVehiculo.marcaEd || datosManuales) ? 'block' : 'none' }}>
                                <Row  >
                                    <Col sm={4}>
                                        <h4><Label for="selectMarca" >Marca </Label></h4>
                                    </Col>
                                    <Col sm={7}  >

                                        <Select1
                                            value={defaulMarca}
                                            //defaultValue={defaulGiro}
                                            components={makeAnimated()}
                                            onChange={({ label, value }, e) => {

                                                this.consultarModelos(value);
                                                this.setState({ datosVehiculo: { ...datosVehiculo, marcaCodigo: value, marcaNombre: `${value}` === '-1' ? '' : label }, hasMarcaError: value ? false : true })
                                            }}
                                            options={marcas}
                                            isSearchable={true}
                                            placeholder={"Seleccione una Marca"}
                                            isMulti={false}
                                        />

                                        {/* <Select
                                        id={"selectMarca"} // Optional.[String].Default: "". Input ID.
                                        name={"selectMarca"} // Optional.[String].Default: "". Input name.
                                        value={marcaCodigo} // Optional.[String].Default: "".
                                        optionList={marcas} // Required.[Array of Object(s)].Default: [].
                                        onChange={(marcaCodigo, e) => { this.consultarModelos(modeloCodigo); this.setState({ datosVehiculo: { ...datosVehiculo, marcaCodigo }, hasMarcaError: false }) }}
                                        validate={validate}
                                        validationCallback={(res) => { console.log('marca', res); this.setState({ hasMarcaError: res, validate: false }) }}
                                        // Optional.[Func].Default: () => {}. Will return the value.
                                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                        validationOption={{
                                            name: "selectMarca", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor seleccione una Marca"
                                        }}
                                    /> */}
                                    </Col>
                                </Row>
                            </div>

                            {((`${marcaCodigo}` === `-1`) || !(datosVehiculo.marcaEd || datosManuales)) &&
                                <Row >
                                    <Col sm={4}>
                                        <h4><Label for="marca" >Ingrese la Marca </Label></h4>
                                    </Col>
                                    <Col sm={7} ><Textbox
                                        //disabled={}

                                        type="text"
                                        id="textMarca"
                                        name="textMarca"
                                        classNameInput={((prVehi.marcaCodigo && prVehi.marcaNombre) && `${marcaCodigo}` !== '-1') ? "input-type-label form-control" : "form-control"}
                                        value={marcaNombre}
                                        validate={validate}
                                        onChange={(marcaNombre, e) => { console.log('ESTADO change marcas2'); this.setState({ datosVehiculo: { ...datosVehiculo, marcaNombre, } }) }}
                                        onBlur={() => { }}
                                        validationCallback={res => { console.log('ESTADO change marcas callback'); this.setState({ hasMarcaError: res, validate: false }) }}
                                        validationOption={{
                                            name: "textMarca", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese la Marca"
                                        }}
                                    />

                                    </Col>
                                </Row>
                            }
                            {((`${marcaCodigo}` !== `-1`) && (!prVehi.modeloCodigo || !prVehi.modeloNombre || datosVehiculo.modeloEd)) &&
                                <Row >
                                    <Col sm={4}>
                                        <h4><Label for="selectModelo" >Modelos </Label></h4>
                                    </Col>
                                    <Col sm={7} >
                                        <Select1
                                            value={defaulModelos}
                                            //defaultValue={defaulGiro}
                                            components={makeAnimated()}
                                            onChange={({ label, value, modCodTipoVehiculo: categoriaCodigo, modDescripcionTipoVehiculo: categoriaNombre }, e) => {
                                                console.log('ESTADO change');
                                                //": value, :

                                                this.setState({ datosVehiculo: { ...datosVehiculo, modeloCodigo: value, modeloNombre: `${value}` === `-1` ? '' : label, categoriaNombre, categoriaCodigo, categoriaEd: `${value}` === `-1` ? true : false }, hasModeloError: value ? false : true, hasCategoriaError: `${value}` === `-1` ? true : false })
                                            }}
                                            options={modelos}
                                            isSearchable={true}
                                            placeholder={"Seleccione un Modelo"}
                                            isMulti={false}
                                        />
                                    </Col>
                                </Row>
                            }

                            {((`${modeloCodigo}` === `-1`) || (`${marcaCodigo}` === `-1`) || !datosVehiculo.modeloEd) &&
                                < Row >
                                    <Col sm={4}>
                                        <h4><Label for="selectModelo" >Modelo </Label></h4>
                                    </Col>
                                    <Col sm={7} >
                                        <Textbox
                                            type="text"
                                            id="textModelo"
                                            name="textModelo"
                                            classNameInput={((prVehi.modeloCodigo && prVehi.modeloNombre) && `${marcaCodigo}` !== '-1') && !datosVehiculo.modeloEd ? "input-type-label form-control" : "form-control"}
                                            style={{ marginTop: 10 }}
                                            value={modeloNombre}
                                            validate={validate}
                                            onChange={(modeloNombre, e) => this.setState({ datosVehiculo: { ...datosVehiculo, modeloNombre } })}
                                            onBlur={() => { }}
                                            validationCallback={res => this.setState({ hasModeloError: res, validate: false })}
                                            validationOption={{
                                                name: "textModelo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                msgOnError: "Por favor ingrese el Modelo"
                                            }}
                                        />


                                    </Col>
                                </Row>
                            }

                            <Row >
                                <Col sm={4} >
                                    <h4 >Motor</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inMotor"
                                        name="inMotor"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.motorEd) ? "form-control" : "input-type-label form-control"}

                                        value={motor}
                                        validate={validate}
                                        onChange={(motor, e) => this.setState({ datosVehiculo: { ...datosVehiculo, motor } })}
                                        onBlur={() => { }}
                                        validationCallback={res => this.setState({ hasMotorError: res, validate: false })}
                                        validationOption={{
                                            name: "inMotor", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese el numero de motor"
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4} >
                                    <h4 >Chasis</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inChasis"
                                        name="inChasis"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.chasisEd) ? "form-control" : "input-type-label form-control"}
                                        value={chasis}
                                        validate={validate}
                                        onChange={(chasis, e) => this.setState({ datosVehiculo: { ...datosVehiculo, chasis } })}
                                        onBlur={() => { }}
                                        validationCallback={res => this.setState({ hasChasisError: res, validate: false })}
                                        validationOption={{
                                            name: "inChasis", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor ingrese el Chasis"
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4} >
                                    <h4 >Año</h4>
                                </Col>
                                <Col sm={7} >
                                    <Textbox

                                        type="text"
                                        id="inYear"
                                        name="inYear"
                                        classNameInput={(`${marcaCodigo}` === `-1` || datosManuales || datosVehiculo.anioEd) ? "form-control" : "input-type-label form-control"}
                                        value={anio}
                                        validate={validate}
                                        onChange={(anio, e) => { this.setState({ datosVehiculo: { ...datosVehiculo, anio } }); setTimeout(() => this.setState({ validate: true }), 300) }}
                                        onBlur={() => { }}
                                        validationCallback={res => { this.setState({ hasAnioError: res, validate: false }) }}
                                        validationOption={{
                                            name: "inYear", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                            min: rangoInf, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                            max: rangoSup,
                                            msgOnError: `Por favor ingrese el año entre ${rangoInf} y ${rangoSup}`
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4}>
                                    <h4><Label for="selectColor" >Color </Label></h4>
                                </Col>
                                <Col sm={7} >

                                    <Select1
                                        value={defaulColor}
                                        //defaultValue={defaulGiro}
                                        components={makeAnimated()}
                                        onChange={({ label, value }, e) => {
                                            this.setState({ datosVehiculo: { ...datosVehiculo, colorCodigo: value, colorNombre: label }, hasColorError: value ? false : true })
                                        }}
                                        options={colores}
                                        isSearchable={true}
                                        placeholder={"Seleccione un Color"}
                                        isMulti={false}
                                    />
                                    {hasColorError && <span style={{ color: '#FA5A77', fontSize: 14, }} >Seleccione un color</span>}

                                </Col>
                            </Row>

                            <Row style={{ display: "none" }}>
                                <Col sm={4}>
                                    <h4><Label for="selecProcedencia" >Procedencia </Label></h4>
                                </Col>
                                <Col sm={7} >
                                    <Select1
                                        value={defaulProcedencia}
                                        //defaultValue={defaulGiro}
                                        components={makeAnimated()}
                                        onChange={({ label, value }, e) => {
                                            this.setState({ datosVehiculo: { ...datosVehiculo, procedenciaCodigo: value, procedenciaNombre: label }, hasProcedenciaError: value ? false : true })
                                        }}
                                        options={procedencia}
                                        isSearchable={true}
                                        placeholder={"Seleccione una procedencia"}
                                        isMulti={false}
                                    />
                                    {hasProcedenciaError && <span style={{ color: '#FA5A77', fontSize: 14, }} >Seleccione una procedencia </span>}
                                    {/* <Select
                                        tabIndex="9" // Optional.[String or Number].Default: none.
                                        id={"selecProcedencia"} // Optional.[String].Default: "". Input ID.
                                        name={"selecProcedencia"} // Optional.[String].Default: "". Input name.
                                        value={procedenciaCodigo} // Optional.[String].Default: "".
                                        optionList={procedencia} // Required.[Array of Object(s)].Default: [].
                                        onChange={(procedenciaCodigo, e) => this.setState({ datosVehiculo: { ...datosVehiculo, procedenciaCodigo } })}
                                        validate={validate}
                                        validationCallback={res => this.setState({ hasProcedenciaError: res, validate: true })}
                                        // Optional.[Func].Default: () => {}. Will return the value.
                                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                                        validationOption={{
                                            name: "selecProcedencia", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            msgOnError: "Por favor seleccione la procedencia del vehículo"
                                        }}
                                    /> */}
                                </Col>
                            </Row>

                            <Row >
                                <Col sm={4}>
                                    <h4><Label for="selecCategoria" >Categoría </Label></h4>
                                </Col>
                                {console.log('????', categoriaNombre, categoriaCodigo, modeloCodigo)}
                                <Col sm={7} >
                                    {((!categoriaNombre && !categoriaCodigo) || `${modeloCodigo}` == '-1' || datosVehiculo.categoriaEd) &&
                                        <Select1
                                            value={defaulCategoria}
                                            //defaultValue={defaulGiro}
                                            style={((prVehi.marcaCodigo && prVehi.marcaNombre) && `${marcaCodigo}` !== '-1') ? "input-type-label form-control" : "form-control"}
                                            components={makeAnimated()}
                                            onChange={({ label, value }, e) => {
                                                console.log('ESTADO change');
                                                this.setState({ datosVehiculo: { ...datosVehiculo, categoriaCodigo: value, categoriaNombre: label }, hasCategoriaError: value ? false : true })
                                            }}
                                            options={categorias}
                                            isSearchable={true}
                                            placeholder={"Seleccione una categoría"}
                                            isMulti={false}
                                        />}
                                    {hasCategoriaError && <span style={{ color: '#FA5A77', fontSize: 14, }} >Seleccione una categoría</span>}
                                    {((prVehi.categoriaNombre && prVehi.categoriaCodigo && `${prVehi.modeloCodigo}` != '-1') || (categoriaNombre && categoriaCodigo && `${modeloCodigo}` != '-1')) && !datosVehiculo.categoriaEd &&
                                        <Textbox
                                            type="text"
                                            id="textModelo"
                                            name="textModelo"
                                            classNameInput={"input-type-label form-control"}
                                            style={{ marginTop: 10 }}
                                            value={prVehi.categoriaNombre || categoriaNombre}
                                            onBlur={() => { }}
                                            validationCallback={res => this.setState({ hasModeloError: res, validate: false })}
                                            validationOption={{
                                                name: "textModelo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            }}
                                        />
                                    }

                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} />
                                <Col md={8}>
                                    {(`${categoriaCodigo}` === '-1') && <Alert color='warning'>{this.props.mensaje}</Alert>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6} className="mt-3" >

                                    <Button className="btn btn-detail-gray" onClick={() => this.props.handleBack()} style={{ display: "block", margin: '0px auto 0px 0px', }} >
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                                    </Button>
                                </Col>
                                <Col md={6} className="mt-3" >

                                    <Button
                                        disabled={(`${categoriaCodigo}` === '-1')}
                                        className="btn btn-primary "
                                        style={{ display: 'block', margin: '0 0 0 auto', }}
                                        onClick={() => { this.onClick() }}>
                                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONTINUAR`}
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </LoadingScreen >

        )
    }
}
